import React, { useEffect, useState } from "react";
import { ArrowRightFromLine, Delete, Pen, Plus } from "lucide-react";
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { createProduct, deleteProduct, getProducts, getProductsStock, updateProduct } from "../../../slices/company/rawProductSlice";
import AddPurchases from "./add_purchases";
import { API_URL } from "../../../utils/constant";
import UpdatePurchaseStockPage from "./add_stock";
import { customTableStyles } from "../../../utils/tableStylings";

const PurchasesStock = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [modalHeading, setModalHeading] = useState('');
    const { stockProducts } = useSelector(state => state.rawProduct);


    const handleReload = () => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(getProductsStock(companyId));
        }
        setShowModal(false);
    }

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(getProductsStock(companyId));
        }
    }, [dispatch]);

    const handleEditTax = (productData) => {
        setSelectedProduct(productData);
        setModalHeading('Update Quantity') // Pass the supplier data to edit
        setShowModal(true);
    };

    const calculateQuantity = (vendors) => {
        let totalQuantity = 0;
        vendors.map((e) => {
            totalQuantity += e.quantity;
        });
        return totalQuantity;
    }

    const calculateFreshQuantity = (PurchasesProducts) => {
        if (Array.isArray(PurchasesProducts) && PurchasesProducts.length > 0) {
            // Use reduce to sum up the quantity_data
            const totalQuantity = PurchasesProducts.reduce((total, vendor) =>
                total + (vendor.unallocated_qty || 0), 0
            );
            return `${totalQuantity}`;
        }
        return '0';
    }


    const productsColumn = [
        {
            name: '#',
            cell: (row, index) => index + 1, // Show index of the row
            width: '50px'
        },
        {
            name: 'Product Name',
            cell: row => (
                <div>
                    <span className="fw-bold">{row.name}</span>
                    {row.isDispensingMaterial && (
                        <span className="badge bg-info text-white ms-2" style={{ fontSize: '10px' }}>
                            Dispensing Material
                        </span>
                    )}
                </div>
            ),
            sortable: true
        },
        {
            name: 'Product Code',
            selector: row => row.sku,
            sortable: true
        },

        {
            name: 'HSN/SAC',
            selector: row => row.hsn_code,
            sortable: true
        },
       
        {
            name: 'Potency & Volume',
            cell: row => {
                const items = row.PurchasesProducts || [];
                if (items.length === 0) return <span className="text-muted">-</span>;
                const map = {};
                items.forEach(item => {
                    const pot = item.potency ? item.potency.trim() : '';
                    const vol = item.volume ? item.volume.trim() : '';
                    const label = [pot, vol].filter(Boolean).join(' ') || (row.isDispensingMaterial ? (row.unit || 'Material') : 'Standard');
                    map[label] = (map[label] || 0) + (item.unallocated_qty || 0);
                });
                return (
                    <div className="d-flex flex-wrap gap-1 py-1">
                        {Object.entries(map).map(([lbl, qty]) => (
                            <span
                                key={lbl}
                                className={`badge ${qty > 0 ? (row.isDispensingMaterial ? 'bg-info text-white' : 'bg-primary text-white') : 'bg-light text-dark border'}`}
                                style={{ fontSize: '12px', fontWeight: 600, padding: '5px 8px' }}
                            >
                                {lbl}: <strong>{qty}</strong>
                            </span>
                        ))}
                    </div>
                );
            },
            width: '220px'
        },
        {
            name: 'Current Quantity',
            selector: row => calculateQuantity(row.RawProductVendors),
            sortable: true
        },
        {
            name: 'Fresh Stock',
            selector: row => calculateFreshQuantity(row.PurchasesProducts),
            sortable: true
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    <button
                        className="text-white btn btn-sm btn-primary cursor-pointer me-2"
                        data-tooltip-id="tooltip"
                        disabled={calculateFreshQuantity(row.PurchasesProducts) > 0 ? false : true}
                        data-tooltip-content="Allocate Fresh Stock"
                        onClick={() => {
                            const isCal = calculateFreshQuantity(row.PurchasesProducts);
                            if (isCal > 0) {
                                handleEditTax(row);
                            }

                        }}
                    >
                        <ArrowRightFromLine />
                    </button>
                </>
            ),
            width: '150px'
        }
    ];



    return (
        <>
            <div className="card" style={{ marginTop: "60px" }}>
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h3 className="text-primary mb-0">Allocate Purchased Items to Stock</h3>
                </div>
                <div className="card-body">
                    <DataTable

                        columns={productsColumn}
                        data={stockProducts}
                        pagination
                        highlightOnHover
                        striped
                        customStyles={customTableStyles}
                        dense
                    />
                </div>
            </div>
            <UpdatePurchaseStockPage show={showModal} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedProduct} onSubmit={handleReload} />
        </>
    );
}

export default PurchasesStock;